/**
 * Thin wrapper around the gtag() that is already installed in public/index.html.
 * Safe to call anywhere: it does nothing if Google Analytics is blocked or not loaded.
 *
 * Events sent (look for them in GA4 > Reports > Engagement > Events):
 *   blog_cta_click      { article, cta_location }   "Connect Instagram" / "See pricing" buttons in an article
 *   blog_related_click  { article, destination }    "Related reading" links
 *   blog_share          { article, method }         share buttons (linkedin, x, whatsapp, copy_link)
 * To count sign-ups from the blog, mark blog_cta_click as a "key event" in GA4.
 */
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch {
    /* analytics must never break the page */
  }
}
